import { autoinject, transient } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipQiRouterConstants } from "../../../../../../configuration/rightshipqi-router.constants"
import { VetOrderService } from "../../../../../../services/vetting/vet-order.service";
import { OrderAbandonRequest } from "../../../../../../models/vetting/vetting.models";
import * as moment from "moment";
import { OrderModel } from "../../../../../../models/rightstore/rightstore.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@transient()
@autoinject
export class FillFormLaterConfirmationDialog {

    public model: FillFormLaterConfirmationDialogModel
    onConfirm: (() => void);
    onCancel: (() => void);

    constructor(private dialogClientService: DialogClientService, private router: Router, private vetOrderService: VetOrderService,
        private configService: ConfigService) {
    }

    activate(model: { order: OrderModel, viewModel: string, viewTitle: string, vesselId: number, onConfirm: (() => void), onCancel: (() => void) }) {
        if (model) {
            this.model = {
                order: model.order,
                viewModel: model.viewModel,
                viewTitle: model.viewTitle,
                vesselId: model.vesselId
            };

            this.onConfirm = model.onConfirm;
            this.onCancel = model.onCancel;
        }
    }

    cancel() {
        this.dialogClientService.hide(true);
        if (this.onCancel) {
            this.onCancel();
        }
    }

    async confirm() {
        const request: OrderAbandonRequest =
        {
            orderGuid: this.model.order.orderGuid,
            orderPurchasedDate: this.model.order.purchaseDate ? moment(this.model.order.purchaseDate).format(this.configService.config.common.defaultDateTimeFormat) : null,
            viewTitle: this.model.viewTitle,
            vesselId: this.model.vesselId,
            optimizlyOrderKey: this.model.order.optimizlyOrderKey
        }
        await this.vetOrderService.abandonScreening(request);
        this.dialogClientService.hide(true);

        if (this.onConfirm) {
            this.onConfirm();
        } else {
            if (this.router.hasRoute(RightShipQiRouterConstants.RouteNames.Activities)) {
                this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.Activities);
            } else {
                window.open(this.configService.config.urls.rightStoreUrl, '_self');
            }
        }
    }
}

export interface FillFormLaterConfirmationDialogModel {
    order: OrderModel;
    viewModel: string;
    viewTitle: string;
    vesselId: number;
}